import React from 'react';
import * as Card from './items/timeline-detail-card.styles';
import { ITimelineEvent } from './claim-timeline.types';
import { getDefaultClaimDataLabel } from './items/claim-data-detail.utils';
import { IClaimDataDetailProps } from './items/claim-data-detail.types';

export interface ITimelineEventDetailProps {
    event: ITimelineEvent;
}

export function hasGenericTimelineEventDetail(item: ITimelineEvent): boolean {
    return (item.detailFields?.length ?? 0) > 0 || !!item.actor;
}

export const TimelineEventDetail = React.memo<ITimelineEventDetailProps>(({ event }) => {
    const fields = event.detailFields ?? [];
    const performedBy = event.actor || event.type;

    if (fields.length === 0 && !performedBy) {
        return null;
    }

    return (
        <Card.CdPanel $embedded>
            <Card.CdSectionCard $embedded>
                <Card.CdFactsGrid>
                    {fields.map((field, index) => (
                        <Card.CdFactCell key={`${field.label}-${index}`}>
                            <Card.CdFactLabel>{field.label}</Card.CdFactLabel>
                            <Card.CdFactValue>{field.value}</Card.CdFactValue>
                        </Card.CdFactCell>
                    ))}
                    {performedBy && (
                        <Card.CdFactCell>
                            <Card.CdFactLabel>Performed by</Card.CdFactLabel>
                            <Card.CdFactValue>{performedBy}</Card.CdFactValue>
                        </Card.CdFactCell>
                    )}
                </Card.CdFactsGrid>
            </Card.CdSectionCard>
        </Card.CdPanel>
    );
});

export function resolveTimelineExpandContent(item: ITimelineEvent): React.ReactNode | null {
    if (item.details) {
        if (
            item.kind === 'claimdata' &&
            item.claimDataNum != null &&
            React.isValidElement(item.details)
        ) {
            return React.cloneElement(item.details as React.ReactElement<IClaimDataDetailProps>, {
                num: item.claimDataNum,
                label: getDefaultClaimDataLabel(item.claimDataNum),
            });
        }

        return item.details;
    }

    if (hasGenericTimelineEventDetail(item)) {
        return <TimelineEventDetail event={item} />;
    }

    return null;
}
